import React from 'react'
import ProgramTitles from '../Component/ProgramTitles'

const Programs = () => {
  return (
    <div className="programs-page">
      {/* Hero Header Section */}
      <div className="programs-hero-banner bg-gradient-to-r from-red-600 to-red-700 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <span className="inline-block px-4 py-1.5 mb-4 text-sm font-semibold tracking-wider uppercase bg-white/20 backdrop-blur-md rounded-full text-white">
            Community Safety & Youth Support
          </span>
          <h1 className="text-4xl md:text-6xl font-extrabold mb-4">Our Core Programs</h1>
          <p className="text-xl md:text-2xl opacity-90 max-w-3xl mx-auto font-light leading-relaxed">
            Evidence-based reintegration, violence prevention, and harm-reduction diversion initiatives serving youth and families across Schenectady County.
          </p>
        </div>
      </div>

      <ProgramTitles />
    </div>
  )
}

export default Programs